export default __webpack_public_path__ + "static/landing-experience-dark-9065553c0076f80ea2e7661d5434a297.png";